import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import Link from "next/link";
import { Recorder } from "react-voice-recorder";
import "react-voice-recorder/dist/index.css";
import Scrollbars from "react-custom-scrollbars";
import { connect } from "react-redux";
import { toast } from "react-hot-toast";
import { FaCheck, FaFileUpload, FaImage, FaTimes } from "react-icons/fa";
import { MdAttachFile } from "react-icons/md";
import {
  setLayer,
  setLoader,
  setLoginPopup,
  toggleLoginForm,
} from "../../../redux/actions/globalAction";
import { usePlacesWidget } from "react-google-autocomplete";
import { useForm } from "react-hook-form";
import axios from "axios";
import {
  setCartBatteryParameter,
  setCartJourney,
  setCartTypeParameter,
  setShowMobileIstand,
} from "../../../redux/actions/cartAction";
import OTPVerifyModal from "../../profile/elements/profile/OTPVerifyModal";
import { getUserAuth, setAuth } from "../../../redux/actions/loginAction";
import { useRouter } from "next/router";
import { TiArrowBack } from "react-icons/ti";
import { GetInfo } from "lib/Location";
import API from "api";
import { UserLoginApi, VerifyOtpApi } from "actions/Auth";
import { SignUpUrl } from "api/Auth";
import { isMobile } from "react-device-detect";
import { base_url, workshopPurchase } from "lib/config";

const audioData = {
  url: null,
  blob: null,
  chunks: null,
  duration: {
    h: 0,
    m: 0,
    s: 0,
  },
};

const QuotationForm = ({
  id,
  cart,
  setLoginPopup,
  globalData,
  loginData,
  setCartJourney,
  getUserAuth,
  setAuth,
  setCartTypeParameter,
  setCartBatteryParameter,
  toggleLoginForm,
  setLayer,
  setShowMobileIstand,
  profile,
  setLoader,
}) => {
  const [audioDetails, setAudioDetails] = useState(audioData);
  const [imageFile, setImageFile] = useState();
  const [documentFile, setDocumentFile] = useState();
  const [audioFile, setAudioFile] = useState();
  const [mulkiaFile, setMulkiaFile] = useState();
  const [recHide, setRecHide] = useState(false);
  const [imageHide, setImageHide] = useState(false);
  const [lat, setLat] = useState(0);
  const [long, setLong] = useState(0);
  const [address, setAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showOTPVerify, setShowOTPVerify] = useState(false);
  const [submitData, setSubmitData] = useState();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [submittingQuote, setSubmittingQuote] = useState(false);

  const router = useRouter();

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isSubmitting, isValid },
  } = useForm();

  const handleAudioStop = (data) => {
    setAudioDetails(data);
  };
  const startRecording = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then(function (stream) {
          setRecHide(!recHide);
        })
        .catch(function (error) {
          toast.dismiss();
          toast.error(
            "Microphone access is disabled on your browser. Please refresh the page after enabling and try again."
          );
        });
    } else {
      toast.dismiss();
      toast.error("Something went wrong! Please retry.");
    }
  };

  const handleAudioUpload = (file) => {
    if (file == null) {
      toast.dismiss();
      toast.error("Please try recording your message again!");
      return;
    }
    setAudioFile(file);
    setRecHide(false);
  };

  const handleCountDown = (data) => {
    console.log(data);
  };

  const handleReset = () => {
    const reset = {
      url: null,
      blob: null,
      chunks: null,
      duration: {
        h: 0,
        m: 0,
        s: 0,
      },
    };
    setAudioDetails(reset);
  };

  const handleImageUpload = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleDocumentUpload = (e) => {
    setDocumentFile(e.target.files[0]);
  };

  const handleMulkiaUpload = (e) => {
    setMulkiaFile(e.target.files[0]);
  };

  const { ref } = usePlacesWidget({
    apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY,
    onPlaceSelected: (place) => {
      const lat = Number(place?.geometry?.location?.lat());
      const lang = Number(place?.geometry?.location?.lng());
      setLat(Number(lat));
      setLong(Number(lang));
    },
    options: {
      types: [],
      componentRestrictions: { country: "AE" },
    },
  });

  const getCurrentLocation = () => {
    locateCurrentPosition()
      .then(async (position) => {
        const lat = Number(position.coords.latitude);
        const lang = Number(position.coords.longitude);
        setLat(Number(lat));
        setLong(Number(lang));
        let addressName = await getAddress(lat, lang);
        setAddress(addressName);
      })
      .catch((e) => {
        GetInfo();
      });
  };

  const locateCurrentPosition = () =>
    new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve(position);
        },
        (error) => {
          console.log(error.message);
          reject(error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 1000,
        }
      );
    });

  const getAddress = async (latitude, longitude) => {
    let data = await axios.post(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY}`
    );
    return data.plus_code.compound_code;
  };

  const removePrefixPostfixSpaces = (inputString) => {
    while (inputString.startsWith(" ")) {
      inputString = inputString?.slice(1);
    }
    while (inputString.endsWith(" ")) {
      inputString = inputString?.slice(0, -1);
    }
    return inputString;
  };

  const handleQuoteAdd = async (data) => {
    debugger
    const Name = removePrefixPostfixSpaces(data.Name);
    const LastName = removePrefixPostfixSpaces(data.LastName);
    const payload = { ...data, Name, LastName };

    setSubmittingQuote(true);
    setTimeout(() => {
      setSubmittingQuote(false);
    }, 20000);
    if (!loginData.userAuth?.Id && !isLoggedIn) {
      let isRegistered = await checkUser(payload);
      if (isRegistered) {
        loginUser(payload);
      } else {
        registerUser(payload);
      }
      return;
    }
    addQuotation(payload);
  };

  const addQuotation = async (data) => {
    setLoader(true);
    let productId = localStorage.getItem("product-id");
    // data.JourneyCategoryId = id;
    // data.Image = imageFile;
    // data.Document = documentFile;
    // data.Audio = audioFile;
    // data.JourneyVariantId = productId;
    // data.CarModelId = globalData.carData?.modelId;
    // data.Lat = lat;
    // data.Lng = long;
    // if (cart.tyreQuotation.isProceed) {
    //   data.Width = cart.tyreQuotation.width;
    //   data.Height = cart.tyreQuotation.height;
    //   data.Rim = cart.tyreQuotation.rim;
    // }
    // if (cart.batteryQuotation.isProceed) {
    //   data.AmpHrs = cart.batteryQuotation.type;
    // }
    const cars = profile.cars.filter(
      (car) => car?.ModelId == globalData.carData?.modelId
    );
    const payload = {
      ...data,
      JourneyCategoryId: id,
      Image: imageFile || null,
      Document: documentFile || null,
      Audio: audioFile || null,
      JourneyVariantId: productId,
      CarModelId: globalData.carData?.modelId,
      CarId: cars && cars.length ? cars[0]?.Id : "0",
      Lat: lat,
      Lng: long,
    };

    if (cart.tyreQuotation.isProceed) {
      payload.Width = cart.tyreQuotation?.width;
      payload.Height = cart.tyreQuotation?.height;
      payload.Rim = cart.tyreQuotation?.rim;
    }
    if (cart.batteryQuotation.isProceed) {
      payload.AmpHrs = cart.batteryQuotation?.type;
    }

    let token = await JSON.parse(localStorage.getItem("login_access"));
    await API.post(`v2/api/customer-quotation-request`, payload, {
      headers: {
        // "Content-Type": "application/x-www-form-urlencoded" ,
        "Content-Type": "multipart/form-data",
        // multipart/form-data
        Authorization: token ? "bearer " + token.access_token : undefined,
      },
    })
      .then(async (res) => {
        // setCartJourney("thankYou");
        if (res?.data?.IsSuccess) {
          localStorage.setItem("quote", JSON.stringify(res.data.Data));
          localStorage.setItem("selected-service", "quote");
          setCartJourney(workshopPurchase);
          router.push("/checkout/thank-you?CustomerPurchaseOrderId=1");
        } else {
          toast.error("Something went wrong! Please retry.");
        }
        setSubmittingQuote(false);
        setLoader(false);
      })
      .catch((err) => {
        console.log("Error ", err);
        toast.dismiss();
        toast.error("Something went wrong! Please retry.");
        setSubmittingQuote(false);
        setLoader(false);
      });
  };

  const checkUser = async (data) => {
    return await API.get(
      `v2/api/customers/0/profile/assets/validate?type=PhoneNumber&value=${data.PhoneNumber}`,
      {
        headers: {
          // "Content-Type": "application/x-www-form-urlencoded" ,
          "Content-Type": "multipart/form-data",
          // multipart/form-data
        },
      }
    )
      .then(async (res) => {
        return !res.data.IsSuccess;
      })
      .catch((err) => {
        console.log("Error ", err);
        setSubmittingQuote(false);
        toast.dismiss();
        toast.error("Something went wrong! Please retry.");
      });
  };

  const registerUser = async (data) => {
    data.FullName = data.Name;
    const res = await SignUpUrl(data);
    const response = res?.data;
    if (response.IsSuccess) {
      setPhoneNumber(data.PhoneNumber);
      setShowOTPVerify(true);
      setSubmitData(data);
    } else {
      setSubmittingQuote(false);
      toast.dismiss();
      toast.error(response?.Message || "Something went wrong! Please retry.");
    }
  };

  const loginUser = async (data) => {
    try {
      const response = await UserLoginApi(data);
      console.log("response --", response);
      if (response?.IsSuccess) {
        setSubmittingQuote(false);
        setPhoneNumber(data.PhoneNumber);
        localStorage.setItem("phoneNumber", data.PhoneNumber);
        setShowOTPVerify(true);
        setSubmitData(data);
      } else {
        setSubmittingQuote(false);
        toast.dismiss();
        toast.error("Something went wrong! Please retry.");
      }
    } catch (error) {
      console.log("Error ", err);
      setSubmittingQuote(false);
      toast.dismiss();
      toast.error("Something went wrong! Please retry.");
    }
  };

  // const sendOTP = () => {
  //   loginUser(submitData)
  // };

  const resendOtp = async (data) => {
    data = submitData;
    const response = await UserLoginApi(data);
    if (response.IsSuccess) {
      toast.dismiss();
      toast.success("OTP Resent Successfully!");
    } else {
      toast.dismiss();
      toast.error("OTP Resending Failed. Please retry.");
    }
  };

  const onOTPVerify = async (otp) => {
    let data = {
      username: phoneNumber,
      password: otp,
      grant_type: "password",
      provider_type: "OTP",
    };
    const response = await VerifyOtpApi(data);
    if (response?.status == 400) {
      toast.dismiss();
      toast.error("Invalid OTP! Please retry.");
      return;
    }
    localStorage.setItem("login_access", JSON.stringify(response.data));
    await setAuth(response.data);
    await getUserAuth();
    toast.dismiss();
    toast.success("OTP Verified Successfully!");
    setPhoneNumber("");
    setShowOTPVerify(false);
    setIsLoggedIn(true);
    addQuotation(submitData);
  };

  const handleBack = () => {
    localStorage.setItem("isCartBack", true);
    let item = cart.tyreQuotation;
    item.isProceed = false;
    item.width = cart.tyreQuotation.width;
    item.height = cart.tyreQuotation.height;
    item.rim = cart.tyreQuotation.rim;
    setCartTypeParameter(item);
  };

  const handleBackBattery = () => {
    localStorage.setItem("isCartBack", true);
    let item = cart.batteryQuotation;
    item.isProceed = false;
    item.type = cart.batteryQuotation.type;
    setCartBatteryParameter(item);
  };
  useEffect(() => {
    if (loginData.userAuth) {
      const {
        PhoneNumber: loginPhoneNumber,
        UserName: loginEmail,
        FirstName: loginFirstName,
        LastName: loginLastName,
      } = loginData.userAuth;
      setValue("PhoneNumber", loginPhoneNumber ? loginPhoneNumber : "");
      setValue("Email", loginEmail ? loginEmail : "");
      setValue("Name", loginFirstName ? loginFirstName : "");
      setValue("LastName", loginLastName ? loginLastName : "");
    }
    return () => {
      if (!localStorage.getItem("isCartBack")) {
        setCartTypeParameter({
          width: null,
          height: null,
          rim: null,
          isProceed: false,
          data: null,
        });
        setCartBatteryParameter({
          type: null,
          isProceed: false,
          data: null,
        });
      }
    };
  }, [loginData]);

  const service_Selected = localStorage.getItem("selected-service-title");

  // Remove double quotes from the value
  const selected_Service = service_Selected
    ? service_Selected.replace(/^"(.*)"$/, "$1")
    : "";

  const handleButtonClick = () => {
    if (
      errors.Name ||
      errors.LastName ||
      errors.ChassisNo ||
      errors.PhoneNumber ||
      errors.Email
    ) {
      // If either field is empty, show a toast notification
      toast.error("Please fill the Required Fields");
    } else {
      // Handle your form submission logic here
      // ...
    }
  };
  return (
    <div
      className="sr-service-dv"
      style={{ paddingTop: "19px", overflow: "hidden" }}
    >
      <Row>
        <form className="w-100" onSubmit={handleSubmit(handleQuoteAdd)}>
          <Col
            className="px-4 quotation mb-3"
            style={{ height: "calc(100vh - 128px)" }}
          >
            <div className="quotation-scrollbar">
              <div className="d-flex  justify-content-between align-items-center">
                <h4>
                  Service Selected:{" "}
                  <span className="text-custom-blue">
                    {cart.tyreQuotation?.isProceed ? "New Tyre" : ""}
                    {cart.batteryQuotation?.isProceed ? "Battery" : ""}
                    {!cart.tyreQuotation?.isProceed &&
                      !cart.batteryQuotation?.isProceed
                      ? cart.selectedQuotationForm?.Name
                      : ""}
                  </span>
                </h4>
                {isMobile &&
                  !cart.tyreQuotation?.isProceed &&
                  !cart.batteryQuotation?.isProceed ? (
                  <img
                    onClick={() => {
                      setShowMobileIstand(false);
                      setLayer(false);
                      localStorage.removeItem("isQuoterequest");
                      setCartJourney(workshopPurchase);
                    }}
                    src="/assets/BACK.png"
                    width="25px"
                    height={25}
                  ></img>
                ) : null}
              </div>
              <p className="text-black description">
                {/* {cart.tyreQuotation.isProceed &&
                  "Please share any details or requirements that can help us to look out for the best Tires Quotes for your car."} */}
                {cart.batteryQuotation.isProceed &&
                  "Please share any details or requirements that can help us to look out for the best Battery Quotes for your car."}
                {!cart.tyreQuotation.isProceed &&
                  !cart.batteryQuotation.isProceed &&
                  `Please share any details or requirements that can help us to look out for the best Quotation for your ${selected_Service}`}
              </p>
              {/* <h4>Request Quotes</h4> */}
              {cart.tyreQuotation.isProceed && (
                <div className="tyre-shadow-box">
                  <div className="d-flex justify-content-between align-items-center my-2">
                    <h5>Selected Tyre Size</h5>
                    <p className="px-2" style={{ cursor: "pointer" }}>
                      <TiArrowBack
                        style={{ width: "25px", height: "25px" }}
                        onClick={handleBack}
                      />{" "}
                    </p>
                  </div>
                  <Container className="text-center mb-4">
                    <Row>
                      <Col xs={4}>
                        <p className="m-0 text-black">Width</p>
                        <span className="bg-grey text-center text-black m-0 px-3 py-1 font-weight-bold">
                          {cart.tyreQuotation.width || "auto"}
                        </span>
                      </Col>
                      <Col xs={4}>
                        <p className="m-0 text-black">Height</p>
                        <span className="bg-grey text-center text-black m-0 px-3 py-1 font-weight-bold">
                          {cart.tyreQuotation.height || "auto"}
                        </span>
                      </Col>
                      <Col xs={4}>
                        <p className="m-0 text-black">Rim</p>
                        <span className="bg-grey text-center text-black m-0 px-3 py-1 font-weight-bold">
                          {cart.tyreQuotation.rim || "auto"}
                        </span>
                      </Col>
                    </Row>
                  </Container>
                </div>
              )}
              {cart.batteryQuotation.isProceed && (
                <div className="tyre-shadow-box">
                  <div className="d-flex justify-content-between my-2">
                    <h5>Selected Size & Details</h5>
                    <p className="px-4" style={{ cursor: "pointer" }}>
                      <TiArrowBack
                        style={{ width: "25px", height: "25px" }}
                        onClick={handleBackBattery}
                      />{" "}
                    </p>
                  </div>
                  <div className="d-flex justify-content-around	my-2 mt-3">
                    <h6>Size</h6>
                    <p className="bg-grey text-center text-black m-0 px-5 py-1 font-weight-bold">
                      {cart.batteryQuotation.type || "auto"}
                    </p>
                  </div>
                </div>
              )}

              <div className="tyre-shadow-box mt-2">
                <h6 className="pb-2">Tell us more?</h6>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    paddingRight: "10px",
                  }}
                >
                  <div
                    style={{
                      height: "50px",
                      background: "#f3f4ff",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      borderRadius: "25px",
                      padding: "18px",
                    }}
                  >
                    <input
                      type="text"
                      style={{
                        border: "none",
                        background: "transparent",
                        width: "100%",
                        fontSize: "14px",
                        color: "#5a5a5a",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                      placeholder="Add Text, Image or Voice Message"
                      {...register("Notes", {
                        required: false,
                      })}
                    />

                    <input
                      id="imageUpload"
                      name="imageUpload"
                      type="file"
                      accept="image/png, image/jpeg"
                      style={{ display: "none" }}
                      onChange={handleImageUpload}
                    />
                  </div>
                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ paddingLeft: "10px", paddingRight: "10px" }}
                  >
                    <label
                      className="m-0 pr-2"
                      for="imageUpload"
                      onClick={() => setImageHide(!imageHide)}
                      style={{ cursor: "pointer" }}
                    >
                      <img src="/assets/repair/camera.svg" alt="camera" />
                    </label>
                    <a
                      onClick={() => {
                        startRecording();
                      }}
                    >
                      {!recHide ? (
                        <img
                          src="/assets/repair/mic.svg"
                          width={38}
                          alt="mic"
                        />
                      ) : (
                        <span
                          className="bg-danger py-1 px-2 text-white"
                          style={{ borderRadius: 20 }}
                        >
                          <FaTimes />
                        </span>
                      )}
                      {/* <img src="/assets/repair/mic.svg" width={44} /> */}
                    </a>
                  </div>
                </div>
                {(imageFile || audioFile) && (
                  <small className="px-5">
                    {imageFile && (
                      <span className="mr-2">
                        <FaCheck /> Image Added
                      </span>
                    )}
                    {audioFile && (
                      <span className="mr-2">
                        <FaCheck /> Voice Added
                      </span>
                    )}
                  </small>
                )}

                {recHide && (
                  <div>
                    <Recorder
                      record={true}
                      title={"New recording"}
                      audioURL={audioDetails.url}
                      showUIAudio
                      handleAudioStop={(data) => handleAudioStop(data)}
                      handleAudioUpload={(data) => handleAudioUpload(data)}
                      handleCountDown={(data) => handleCountDown(data)}
                      handleReset={() => handleReset()}
                    // mimeTypeToUseWhenRecording={`audio/webm`} // For specific mimetype.
                    />
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    padding: "0 10px",
                    paddingLeft: "0px",
                  }}
                  className="mt-2"
                >
                  <div
                    style={{
                      height: "50px",
                      background: "#F5F5F5",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      borderRadius: "25px",
                      padding: "18px",
                    }}
                  >
                    <input
                      type="text"
                      // disabled={true}
                      style={{
                        border: "none",
                        background: "transparent",
                        width: "100%",
                        fontSize: "14px",
                        color: "#5a5a5a",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                      placeholder="Have a quote from another garage?"
                    />
                    <label
                      for="documentUpload"
                      className="hide-in-mobile text-white"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        // width: "80%",
                        background:
                          "linear-gradient(0deg, rgba(247,146,34,1) 0%, rgba(255,50,1,1) 100%)",
                        borderRadius: "25px",
                        padding: "7px 13px",
                        cursor: "pointer",
                        marginBottom: "0px",
                      }}
                    >
                      {/* <img src="/assets/repair/pdf.svg" /> */}
                      {/* <FaFileUpload /> */}
                      <FaImage />
                      <div
                        style={{
                          color: "#Fff",
                          fontSize: "14px",
                          marginLeft: "6px",
                        }}
                      >
                        Upload
                      </div>
                    </label>
                    <label
                      for="documentUpload"
                      className="for-mobile m-0"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#F58B1F",
                        borderRadius: "25px",
                        padding: "7px 10px",
                        cursor: "pointer",
                      }}
                    >
                      {/* <img src="/assets/repair/pdf.svg" /> */}
                      <FaImage style={{ fill: "white" }} />
                    </label>
                    <input
                      id="documentUpload"
                      name="documentUpload"
                      type="file"
                      accept="image/*,application/pdf"
                      style={{ display: "none" }}
                      onChange={handleDocumentUpload}
                    />
                  </div>
                </div>
                {documentFile && (
                  <small className="px-5">
                    <span className="mr-2">
                      <FaCheck /> Document Added
                    </span>
                  </small>
                )}
                {(cart.batteryQuotation.isProceed ||
                  cart.tyreQuotation.isProceed) && (
                    <div style={{ padding: "0px 10px 10px 10px", width: "100%" }}>
                      <div className="custom-control custom-checkbox mt-3 mb-2">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="customCheck1"
                          {...register("IsRequestAtHome")}
                          value={false}
                        />
                        <label
                          className="custom-control-label d-flex align-items-center"
                          htmlFor="customCheck1"
                        >
                          Need Installation at Your Location
                        </label>
                      </div>
                    </div>
                  )}
                <div
                  style={{
                    height: "50px",
                    position: "relative",
                    background: "#F5F5F5",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    marginTop: "10px",
                    borderRadius: "25px",
                    padding: "18px",
                  }}
                >
                  <input
                    type="text"
                    placeholder="Chassis Number"
                    style={{
                      paddingRight: "194px",
                      border: "none",
                      background: "transparent",
                      width: "100%",
                      fontSize: "14px",
                      color: "#5a5a5a",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                    }}
                    {...register("ChassisNo")}
                    className=""
                  />
                  <div
                    style={{ position: "absolute", top: "7px", right: "2px" }}
                  >
                    <label
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        padding: "10px",
                        cursor: "pointer",
                      }}
                      htmlFor="mulkiaUpload"
                    >
                      <div
                      // style={{
                      //   height: "50px",
                      //   background: "#F5F5F5",
                      //   display: "flex",
                      //   flexDirection: "row",
                      //   justifyContent: "center",
                      //   alignItems: "center",
                      //   width: "100%",
                      //   borderRadius: "25px",
                      //   padding: "18px",
                      // }}
                      >
                        <div style={{ fontSize: "12px", color: "#5a5a5a" }}>
                          {mulkiaFile ? (
                            <span>
                              <FaCheck /> Mulkia Attached
                            </span>
                          ) : (
                            <>
                              <MdAttachFile
                                style={{
                                  color: "#0451be",
                                  fontSize: 13,
                                  transform: "rotate(30deg)",
                                }}
                              />
                              Attach Registration Card
                            </>
                          )}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                {errors.ChassisNo && (
                  <span
                    className="text-danger"
                    style={{ fontSize: "12px", marginLeft: "10px" }}
                  >
                    ChassisNo. is required
                  </span>
                )}
                <input
                  id="mulkiaUpload"
                  name="mulkiaUpload"
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleMulkiaUpload}
                />
              </div>
              <div className="tyre-shadow-box mt-2 mb-2">
                <div className="row">
                  <div className="col">
                    <div
                      style={{
                        height: "50px",
                        position: "relative",
                        background: "#F5F5F5",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        marginTop: "10px",
                        borderRadius: "25px",
                        padding: "18px",
                      }}
                    >
                      <input
                        type="text"
                        placeholder="First Name"
                        style={{
                          border: "none",
                          background: "transparent",
                          width: "100%",
                          fontSize: "14px",
                          color: "#5a5a5a",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                        {...register("Name", {
                          required: true,
                        })}
                        onKeyPress={(event) => {
                          if (/\d/.test(event.key)) {
                            // test if the pressed key is a number
                            event.preventDefault(); // prevent the input of numeric values
                          }
                        }}
                        onPaste={(event) => {
                          const clipboardData =
                            event.clipboardData || window.clipboardData;
                          const pastedData = clipboardData.getData("text");
                          if (/\d/.test(pastedData)) {
                            // test if the clipboard contents contain numeric values
                            event.preventDefault(); // prevent the paste operation
                          }
                        }}
                        className=""
                      />
                    </div>
                    {errors.Name && (
                      <span
                        className="text-danger"
                        style={{ fontSize: "12px", marginLeft: "10px" }}
                      >
                        First Name is required
                      </span>
                    )}
                  </div>
                  <div className="col">
                    <div
                      style={{
                        height: "50px",
                        position: "relative",
                        background: "#F5F5F5",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        marginTop: "10px",
                        borderRadius: "25px",
                        padding: "18px",
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Last Name"
                        style={{
                          border: "none",
                          background: "transparent",
                          width: "100%",
                          fontSize: "14px",
                          color: "#5a5a5a",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                        {...register("LastName", {
                          required: true,
                        })}
                        onKeyPress={(event) => {
                          if (/\d/.test(event.key)) {
                            // test if the pressed key is a number
                            event.preventDefault(); // prevent the input of numeric values
                          }
                        }}
                        onPaste={(event) => {
                          const clipboardData =
                            event.clipboardData || window.clipboardData;
                          const pastedData = clipboardData.getData("text");
                          if (/\d/.test(pastedData)) {
                            // test if the clipboard contents contain numeric values
                            event.preventDefault(); // prevent the paste operation
                          }
                        }}
                        className=""
                      />
                    </div>
                    {errors.LastName && (
                      <span
                        className="text-danger "
                        style={{ fontSize: "12px", marginLeft: "10px" }}
                      >
                        Last Name is required
                      </span>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    height: "50px",
                    position: "relative",
                    background: "#F5F5F5",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    marginTop: "10px",
                    borderRadius: "25px",
                    padding: "18px",
                  }}
                >
                  <div className="d-flex w-100 ">
                    <div className="d-flex align-items-center px-2" style={{}}>
                      <p className="text-black d-flex align-items-center">
                        <svg
                          width={31}
                          height={30}
                          viewBox="0 0 31 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.0083 29.8114C23.2886 29.8114 30.0011 23.1539 30.0011 14.9414C30.0011 6.72885 23.2886 0.0712891 15.0083 0.0712891C6.72809 0.0712891 0.015625 6.72885 0.015625 14.9414C0.015625 23.1539 6.72809 29.8114 15.0083 29.8114Z"
                            fill="#F0F0F0"
                          />
                          <path
                            d="M8.55469 20.2178L9.86998 29.0672C13.6317 30.4476 17.792 30.2911 21.4374 28.6319C25.0828 26.9727 27.9154 23.9465 29.3132 20.2178H8.55469Z"
                            fill="black"
                          />
                          <path
                            d="M8.55469 9.78162L9.86998 0.932157C13.6314 -0.447474 17.791 -0.290494 21.4359 1.36864C25.0807 3.02778 27.9129 6.05349 29.3107 9.78162H8.55469Z"
                            fill="#6DA544"
                          />
                          <path
                            d="M8.06025e-10 14.9987C-3.18685e-05 18.0616 0.944996 21.0512 2.70814 23.5658C4.47128 26.0805 6.96809 27.9997 9.86317 29.0658V0.932129C6.96817 1.99817 4.47142 3.91736 2.70829 6.4319C0.945148 8.94643 7.18711e-05 11.9359 8.06027e-10 14.9987H8.06025e-10Z"
                            fill="#A2001D"
                          />
                        </svg>
                        +971
                      </p>
                    </div>
                    <input
                      type="text"
                      onKeyDown={(e) => {
                        const isCtrlKey = e.ctrlKey || e.metaKey; // Check if "ctrl" or "cmd" key is pressed
                        const keyValue = e.key;
                        const numericRegex = /^[0-9]*$/;
                        if (
                          !(
                            numericRegex.test(keyValue) ||
                            isCtrlKey ||
                            keyValue === "Backspace"
                          )
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        const pastedValue = e.clipboardData.getData("text");
                        const numericRegex = /^[0-9]*$/;
                        if (!numericRegex.test(pastedValue)) {
                          e.preventDefault();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(
                            0,
                            e.target.maxLength
                          );
                      }}
                      maxLength={9}
                      style={{
                        border: "none",
                        background: "transparent",
                        width: "100%",
                        fontSize: "14px",
                        color: "#5a5a5a",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                      className=" px-1"
                      placeholder="Phone Number"
                      {...register("PhoneNumber", {
                        required: true,
                        validate: (value) => {
                          return (
                            value[0] == "5" &&
                            (value[1] === "5" ||
                              value[1] === "2" ||
                              value[1] === "1" ||
                              value[1] === "0" ||
                              value[1] === "6" ||
                              value[1] === "4" ||
                              value[1] === "8") &&
                            value.length === 9
                          );
                        },
                      })}
                    />
                  </div>
                </div>
                {errors.PhoneNumber && (
                  <span
                    className="text-danger"
                    style={{ fontSize: "12px", marginLeft: "10px" }}
                  >
                    Enter valid phone number.
                  </span>
                )}
                <div
                  style={{
                    height: "50px",
                    position: "relative",
                    background: "#F5F5F5",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    marginTop: "10px",
                    borderRadius: "25px",
                    padding: "18px",
                  }}
                >
                  <input
                    type="email"
                    placeholder="Enter Your Email"
                    Name="Email"
                    style={{
                      border: "none",
                      background: "transparent",
                      width: "100%",
                      fontSize: "14px",
                      color: "#5a5a5a",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                    }}
                    {...register("Email", {
                      required: true,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "invalid email address",
                      },
                    })}
                    className=""
                  />
                </div>
                {errors.Email && (
                  <span
                    className="text-danger"
                    style={{ fontSize: "12px", marginLeft: "10px" }}
                  >
                    Email is required & valid
                  </span>
                )}
                {!loginData.userAuth?.Id && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      padding: "10px 10px 30px 10px",
                    }}
                  >
                    {/* <div style={{ color: "#F58B1F" }}>
                      Note: OB will create accout for you
                    </div> */}
                    <div
                      className="hide-in-mobile"
                      style={{
                        margin: "5px",
                        cursor: "auto",
                        color: "rgb(138, 60, 144)",
                      }}
                    >
                      Already a user?{" "}
                      <span
                        className="text-primary"
                        style={{ cursor: "pointer" }}
                      >
                        Login
                      </span>
                    </div>
                    <div
                      className="for-mobile text-primary"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setLoginPopup(true);
                        toggleLoginForm(true);
                      }}
                    >
                      Login
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              className={`quote-request-btn workshop-bottom-button mt-5 m-0 border-none text-white ${!isMobile ? "position-absolute" : "position-fixed"
                } p-0 rounded-0`}
              style={{
                width: "90%",
                background: "#fff",
                boxShadow: "none",
                bottom: 0,
                minHeight: "75px",
                left: "25px",
                right: "0",
              }}
            >
              <button
                onClick={handleButtonClick}
                style={
                  !submittingQuote && isValid
                    ? {
                      fontSize: 20,
                      width: "90%",
                      background:
                        "linear-gradient(0deg, rgba(247,146,34,1) 0%, rgba(255,50,1,1) 100%)",
                      border: "none",
                    }
                    : {
                      fontSize: 20,
                      background: "rgb(87, 112, 139)",
                      color: "#ffffff",
                      cursor: "initial",
                      width: "90%",
                      border: "none",
                    }
                }
                className="quote-request-button"
                type="submit"
                disabled={submittingQuote || !isValid}
              >
                SUBMIT
                <span className="font-weight-bold ml-1">QUOTE REQUEST</span>
                {submittingQuote && (
                  <Spinner
                    animation="grow"
                    role="status"
                    className="ml-2"
                    size="sm"
                  >
                    <span className="visually-hidden"></span>
                  </Spinner>
                )}
              </button>
            </div>
          </Col>

          {/* <button
                className="quote-request-btn workshop-bottom-button mt-5 w-100 m-0 border-none text-white position-absolute"
                style={
                  !submittingQuote
                    ? { fontSize: 20 }
                    : {
                        fontSize: 20,
                        background: "#57708b",
                        color: "#ffffff",
                        cursor: "initial",
                      }
                }
                type="submit"
                disabled={submittingQuote}
              >
                SUBMIT
                <span className="font-weight-bold ml-1">QUOTE REQUEST</span>
                {submittingQuote && (
                  <Spinner
                    animation="grow"
                    role="status"
                    className="ml-2"
                    size="sm"
                  >
                    <span className="visually-hidden"></span>
                  </Spinner>
                )}
              </button> */}
        </form>
      </Row>
      <OTPVerifyModal
        show={showOTPVerify}
        setShow={setShowOTPVerify}
        onOTPVerify={onOTPVerify}
        sendOTP={resendOtp}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    cart: state.cart,
    loginData: state.loginData,
    profile: state.profile,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setLoginPopup: (stage) => {
      dispatch(setLoginPopup(stage));
    },
    setCartJourney: (stage) => {
      dispatch(setCartJourney(stage));
    },
    getUserAuth: () => {
      dispatch(getUserAuth());
    },
    setAuth: (data) => {
      dispatch(setAuth(data));
    },
    setCartTypeParameter: (data) => {
      dispatch(setCartTypeParameter(data));
    },
    setCartBatteryParameter: (data) => {
      dispatch(setCartBatteryParameter(data));
    },
    toggleLoginForm: (stage) => {
      dispatch(toggleLoginForm(stage));
    },
    setLayer: (status) => {
      dispatch(setLayer(status));
    },
    setShowMobileIstand: (flag) => {
      dispatch(setShowMobileIstand(flag));
    },
    setLoader: (flag) => {
      dispatch(setLoader(flag));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuotationForm);
